import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { u as useTileGroupContext } from '../TileGroupContext-7a3e30fb.js';
import { M as Main, b as Checkbox, I as IconWrapper, T as Title, B as Body, S as SubText } from './Tile.styles-8f5e4b44.js';
import { u as useTileContext, b as useTileControlContext } from './TileContext-6a6f8a8c.js';
import { T as TileBox } from './TileBox-1f2ed97d.js';
import { T as TileToggleArea } from './TileToggleArea/TileToggleArea-215b02fa.js';

const StyledTileBox = /*#__PURE__*/styled(TileBox).withConfig({
  componentId: "sc-storm-ui-30051113__sc-wrcm97-0"
})(["flex:1;"]);
const TileControl = ({
  hideStartBorder,
  renderIcon,
  subText,
  text,
  title,
  titleFontSize
}) => {
  const {
    multiple,
    name
  } = useTileGroupContext();
  const {
    disabled,
    selected
  } = useTileContext();
  const {
    focusProps,
    label,
    onChange,
    value,
    dataTaktAttributes,
    innerRef,
    restProps
  } = useTileControlContext();
  return /*#__PURE__*/React__default.createElement(StyledTileBox, {
    hideStartBorder: hideStartBorder,
    paddingBlockStart: "none",
    paddingBlockEnd: "none",
    paddingInlineStart: "none",
    paddingInlineEnd: "none"
  }, /*#__PURE__*/React__default.createElement(TileToggleArea, _extends({}, dataTaktAttributes, restProps, {
    checked: selected,
    disabled: disabled,
    focusProps: focusProps,
    label: label,
    multiple: multiple,
    name: name,
    onChange: onChange,
    ref: innerRef,
    value: value
  }), /*#__PURE__*/React__default.createElement(Main, null, multiple && /*#__PURE__*/React__default.createElement(Checkbox, {
    checkboxSize: "medium",
    $checked: selected,
    $disabled: disabled
  }), renderIcon && /*#__PURE__*/React__default.createElement(IconWrapper, null, renderIcon({
    disabled,
    selected
  })), /*#__PURE__*/React__default.createElement("div", null, title && /*#__PURE__*/React__default.createElement(Title, {
    $titleFontSize: titleFontSize
  }, title), text && /*#__PURE__*/React__default.createElement(Body, null, text), subText && /*#__PURE__*/React__default.createElement(SubText, null, subText)))));
};
TileControl.defaultProps = {
  hideStartBorder: false,
  renderIcon: undefined,
  subText: undefined,
  text: undefined,
  title: undefined,
  titleFontSize: 'base'
};
TileControl.propTypes = {
  /**
   * Set this to true to hide TileControl's start border.
   */
  hideStartBorder: PT.bool,
  /**
   * Render prop for icon of the Tile.
   */
  renderIcon: PT.func,
  /**
   * Extra content of the Tile.
   */
  subText: PT.string,
  /**
   * Content of the Tile.
   */
  text: PT.string,
  /**
   * Title of the Tile.
   */
  title: PT.string,
  /**
   * Font size of the title.  ("base" or "large")
   */
  titleFontSize: PT.oneOf(['base', 'large'])
};
var TileControl$1 = TileControl;

export { TileControl$1 as T };
//# sourceMappingURL=TileControl-d315f7a4.js.map
